import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setDialogAction,
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import { HttpStatusCodeEnum } from '@/enums'
import { PlayerCardActionTypes } from '../constants'

import { PLAYER_CARD } from './api.routes'
import { PlayerCardModels } from '../'

const apiService: RestApiService = Container.get(RestApiService)

export const updatePlayerDataThunk = createAsyncThunk(
  PlayerCardActionTypes.UPDATE_PLAYER,
  async (payload: PlayerCardModels.UpdatePlayerPayload, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoadingFullAction(true))

      const { auth } = thunkAPI.getState() as ApplicationState

      apiService.requestParams = {
        method: 'PATCH',
        endpoint: `${PLAYER_CARD.UPDATE_PLAYER}/${payload.id}`,
        // endpoint: `${PLAYER_CARD.UPDATE_PLAYER}/${auth.brand.siteId.toString()}/${
        //   payload.id
        // }`,
        queries: jsonToQueryString({
          brandId: auth.brand.siteId.toString(),
          // brandId: 'f1c808ad-dda5-4aa5-8553-63f99562ad05',
        }),
        body: payload,
        isIncentiveAPI: true,
      }

      const response: PlayerCardModels.GetPlayerResponse =
        await apiService.sendData(auth.brand.siteId.toString(), auth.token)

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('labels.player').toLowerCase()} ${payload.id}`,
        what: i18n.t('messages.updated'),
      })

      if (
        response.statusCode &&
        response.statusCode !== HttpStatusCodeEnum.OK
      ) {
        message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')
      } else {
        thunkAPI.dispatch(setDialogAction({ open: false }))
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant:
            response.statusCode && response.statusCode !== HttpStatusCodeEnum.OK
              ? 'error'
              : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
    }
  },
)

export const updatePlayerExtraReducer = (
  builder: ActionReducerMapBuilder<PlayerCardModels.PlayerCardState>,
) => {
  builder.addCase(updatePlayerDataThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(
    updatePlayerDataThunk.fulfilled,
    (state, { payload, meta }) => {
      state.isLoading = false
      state.playerCard =
        payload.statusCode && payload.statusCode !== HttpStatusCodeEnum.OK
          ? meta.arg
          : payload
    },
  )
}
